'use client'
import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__ImageVariants_js_3c3a0a87__ from "./ImageVariants.js";
const DEFAULT_IMAGE = 'https://s1.pclncdn.com/design-assets/brand-assets/default_image.jpeg';
const Image = ({ src = DEFAULT_IMAGE, alt, width, maxWidth, height, maxHeight, ratio, borderRadius, shadow, objectFit, objectPosition, isLoading, className, isSvg, ...props })=>{
    const classes = (0, __WEBPACK_EXTERNAL_MODULE__ImageVariants_js_3c3a0a87__.image)({
        width,
        maxWidth,
        height,
        maxHeight,
        ratio,
        borderRadius,
        shadow,
        objectFit,
        objectPosition,
        isLoading,
        className,
        isSvg
    });
    const combinedClasses = ratio ? `${classes} aspect-${ratio}` : classes;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("img", {
        src: src,
        alt: alt,
        className: combinedClasses,
        ...props,
        style: {
            aspectRatio: ratio
        },
        decoding: "async"
    });
};
export { Image };
